import { takeEvery, takeLatest } from 'redux-saga/effects';
import { CREATE_ROLE, DELETE_ROLE, GET_PERMISSION, GET_USERS_WITH_ROLES, MANAGE_ROLE, UPDATE_ROLE } from 'roles/redux.actionTypes';
import createRoleWorker from './rolesSagas/createRoleWorker';
import deleteRoleWorker from './rolesSagas/deleteRoleWorker';
import getPermissionWorker from './rolesSagas/getPermissionWorker';
import getUsersWithRolesWorker from './rolesSagas/getUsersWithRolesWorker';
import manageRoleWorker from './rolesSagas/manageRoleWorker';
import updateRoleWorker from './rolesSagas/updateRoleWorker';


export default function* () {
    yield takeLatest(CREATE_ROLE, createRoleWorker);
    yield takeLatest(DELETE_ROLE, deleteRoleWorker);
    yield takeLatest(GET_PERMISSION, getPermissionWorker);
    yield takeLatest(UPDATE_ROLE, updateRoleWorker);
    yield takeLatest(MANAGE_ROLE, manageRoleWorker);
    yield takeEvery(GET_USERS_WITH_ROLES, getUsersWithRolesWorker);
}